import * as priority from 'priority-web-sdk';
import {isRTL} from '../../../../Localization';
import {Filter} from 'priority-web-sdk';
import {noop} from '@priority-software/priority-style-react/dist';
import {getLoginConfig} from '../../../../services/proto/core/server';
import {getCompanyName} from '../../../../utils/proto-api-utils/utils';

const filterValue: Filter = {
    or: 0,
    ignorecase: 1,
    QueryValues: [
        {
            field: 'CATENAME',
            fromval: 'Onboarding Zoom IL',
            op: '=',
            sort: 1,
            isdesc: 0
        }
    ]
};

const formName = 'WWWSHOWONBOARD';

export class SummaryService {
    activeForms = {};

    async startAction() {
        try {
            const form = await this.startForm();
            const activateRes = await form.activateStart(formName, 'P', noop);
            await this.actionSuccess(activateRes);
        } catch (e) {
            throw Error(e as string);
        }
    }

    userLogin = async () => {
        try {
            await priority.login(getLoginConfig());
        } catch (e) {
            throw Error(e as string);
        }
    };

    startForm = async () => {
        try {
            await this.userLogin();

            const currCompany = getCompanyName();
            const activeForm = this.activeForms[currCompany];

            if (!activeForm) {
                const form = await priority.formStart(
                    'ONBOARDINGCAT',
                    noop,
                    noop,
                    getCompanyName(),
                    0
                );

                await form.setSearchFilter(filterValue);

                await form.getRows(1);

                await form.setActiveRow(1);

                this.activeForms[currCompany] = form;

                return form;
            }

            return this.activeForms[currCompany];
        } catch (e) {
            throw Error(e as string);
        }
    };

    procDocumentOptions = async data => {
        const selectedFormat = isRTL() ? -1 : -2;

        return await data.proc.documentOptions(1, selectedFormat, {pdf: 1, word: 1});
    };

    actionSuccess = async data => {
        const {type} = data;

        try {
            if (type === 'documentOptions') {
                const res = await this.procDocumentOptions(data);

                await this.actionSuccess(res);
            } else if (type === 'displayUrl') {
                const res = await this.procDisplayUrl(data);
                await this.actionSuccess(res);
            }
        } catch (e) {
            await this.procError(e, data);
        }
    };

    procDisplayUrl = async data => {
        if (data.Urls && data.Urls[0].action === 'display') {
            const newWin = window.open(encodeURI(data.Urls[0].url), '_blank');

            if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                throw new Error('Popup blocked');
            }
        }

        await data.proc.continueProc();
    };

    procError = async (reason, data) => await data.proc.cancel();
}

export const summaryService = new SummaryService();
